import { render } from "./AppCollectionBadge.vue?vue&type=template&id=470fb34a"
import script from "./AppCollectionBadge.vue?vue&type=script&lang=js"
export * from "./AppCollectionBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__